import type { HTMLAttributes } from "react";

/** Correspond aux badges de `CarteProduit` (VVS_MODELE_INTERFACE.md §0.3). Porté à l'identique depuis apps/web/components/ui/Badge.tsx. */
export type BadgeTone = "promo" | "new" | "outOfStock" | "neutral";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  promo: "bg-gold text-navy",
  new: "bg-navy text-cream",
  outOfStock: "bg-red-600 text-white",
  neutral: "bg-cream2 text-ink",
};

export function Badge({ tone = "neutral", className = "", ...props }: BadgeProps) {
  return (
    <span
      className={[
        "inline-flex items-center rounded-sm px-2 py-1 font-body text-[11px] font-semibold uppercase tracking-wide",
        TONE_CLASSES[tone],
        className,
      ].join(" ")}
      {...props}
    />
  );
}
